import api from "./api";
import queryString from "query-string";

export default {
  fetchAll(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `virtual_content`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.virtual_content);
        }
      );
    });
  },

  fetchByIds(apiKey, ids) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `virtual_content`,
          qs: {
            conditions: JSON.stringify({
              _id: { $in: ids }
            })
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.virtual_content);
        }
      );
    });
  },

  fetchOne(apiKey, virtualContent) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `virtual_content/${virtualContent}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve({ ...response, _fetched_at: Date.now() });
        }
      );
    });
  },

  edit(apiKey, virtualContent, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content/${virtualContent}`,
          json: values,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, virtualContent) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `virtual_content/${virtualContent}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content`,
          json: values,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  upload(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content/${id}/upload`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  export(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content/${id}/export`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  uploadSignature(apiKey, id, query) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint:
            `virtual_content/${id}/upload_signature?` +
            queryString.stringify(query),
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchChatReviewQueue(apiKey, id, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `watch/${id}/admin_chat_review_queue`,
          json: options,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  submitChatReviewAction(apiKey, virtualContentId, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `watch/${virtualContentId}/admin_chat_action`,
          json: options,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  startStreaming(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content/${id}/start_streaming`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  stopStreaming(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `virtual_content/${id}/stop_streaming`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/VirtualContentUtil.js